import { Actions, ActionTypes } from '../actions/auth.action';
import { AuthWithMfaDetails } from '../models/auth.model';

export const initialState: AuthWithMfaDetails = {
  id: 0,
  email: '',
  name: '',
  organization: null,
  role: null,
  token: null,
  refresh_token: null,
  mfaToken: null,
  isTotpEnabled: false,
  authMethod: 'otp',
};

export function authReducer(state = initialState, action: Actions) {
  switch (action.type) {
    case ActionTypes.SIGN_IN:
      return {
        ...state,
        ...action.payload,
      };
    case ActionTypes.SIGN_OUT:
      return initialState;
    case ActionTypes.UPDATE_EMAIL:
      return {
        ...state,
        email: action.payload,
      };
    case ActionTypes.UPDATE_AUTH_TOKEN:
      return {
        ...state,
        token: action.payload,
      };
    case ActionTypes.UPDATE_REFRESH_TOKEN:
      return {
        ...state,
        refresh_token: action.payload,
      };
    case ActionTypes.UPDATE_SIGNIN_RESPONSE:
      return {
        ...state,
        mfaToken: action.payload.mfaToken,
        isTotpEnabled: action.payload.isTotpEnabled,
        authMethod: action.payload.authMethod,
      };
    case ActionTypes.UPDATE_AUTHENTICATION_METHOD:
      return {
        ...state,
        isTotpEnabled: action.payload,
      };
    case ActionTypes.UPDATE_AUTHENTICATION_METHOD_INTERNAL_HANDLING:
      return {
        ...state,
        authMethod: action.payload,
      };
    default:
      return state;
  }
}
